var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-select', {
    staticStyle: {
      "min-width": "200px"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.options, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.option_id
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]);
  }), 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };